/* eslint-disable no-param-reassign */
import axios from 'axios';

const fetch = axios.create({
  baseURL: `${process.env.REACT_APP_API_BASE_URL}`,
  headers: {
    'Content-Type': 'application/json',
  },
});

fetch.interceptors.request.use(
  (config: any) => {
    // Do something before request is sent
    // eslint-disable-next-line no-param-reassign

    config.headers.authorization = `Bearer ${localStorage.getItem(
      'access_token',
    )}`;
    config.url = config.baseURL + config.url;
    return config;
  },
  (error) =>
    // Do something with request error
    Promise.reject(error),
);

fetch.interceptors.response.use(
  (res: any) => {
    return res;
  },
  (err: any) => {
    console.log(err);
    return { data: {} };
  },
);

export const fetcher = () => {
  const accessToken = localStorage.getItem('access_token');

  if (accessToken) {
    return fetch;
  }

  return {
    post: () => new Promise((resolve) => resolve('')),
    get: () => new Promise((resolve) => resolve('')),
    delete: () => new Promise((resolve) => resolve('')),
    patch: () => new Promise((resolve) => resolve('')),
    put: () => new Promise((resolve) => resolve('')),
  };
};
export const getRequest = async (url: string) => fetcher().get(url);
export const postRequest = async (url: string, options: any) =>
  fetcher().post(url, options);
export const postFile = async (url: string, data: FormData, options: any) =>
  fetcher().post(url, data, options);
export const patchRequest = async (url: string, options: any) =>
  fetcher().patch(url, options);
export const deleteRequest = async (url: string, options: any) =>
  fetcher().delete(url, options);

/**
 * Parses the JSON returned by a network request
 * @param  {object} response A response from a network request
 * @return {object}          The parsed JSON from the request
 */
function parseJSON(response: any) {
  if (response.status === 204 || response.status === 205) {
    return null;
  }
  return response.json();
}

/**
 * Checks if a network request came back fine, and throws an error if not
 * @param  {object} response   A response from a network request
 * @return {object|undefined} Returns either the response, or throws an error
 */
function checkStatus(response: any) {
  if (response.status >= 200 && response.status < 300) {
    return response;
  }

  throw new Error(response.statusText);
}

/**
 * Requests a URL, returning a promise
 * @param  {string} url       The URL we want to request
 * @param  {object} [options] The options we want to pass to "fetch"
 * @return {object}           The response data
 */
export default function request(url: string, options: any) {
  return fetch(url, options).then(checkStatus).then(parseJSON);
}

const API = {
  insights: 'insights',
  channelAgentMapping: 'channel_agent_map',
  visualConfig: 'config',
  uploadThumbnail: 'upload_thumbnail',
  getVisuals: 'visualList',
  getSingleVisuals: 'singleVisualList',
};
export { API };
